import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import {Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-after-login-layout',
  templateUrl: './after-login-layout.component.html',
  styleUrls: ['./after-login-layout.component.scss']
})
export class AfterLoginLayoutComponent implements OnInit {

  activelang:string = localStorage.getItem('_lang');
  settingsData:any = {};
  public userData:any;
  currentRoute:any = '';
  headerData:any = {};
  constructor(
    public translate: TranslateService,
    private cService: CommonService,
    private httpRequestService: HttpRequestService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
      this.cService.activelang.subscribe((lang) => {
      
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
  
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
      });
    }

    activeRouteName:any = '';
  ngOnInit() {
    this.cService.activeRoute.subscribe((url)=>{
      this.activeRouteName = url;
      console.log(this.activeRouteName);
    });
    this.userData = this.cService.getLoginUserDetails();
    this.httpRequestService.setModule('action').post('site_settings',{}).subscribe((response:any) => {
      if (response.status == 'error') {
        this.toastr.error( response.data,'Error:');
      } else {
        this.headerData = response.data; 
        for(let i=0; i<response.data.length; i++){
          let item = response.data[i];
          this.settingsData[item.param_name] = item.param_value;
        };
      }
    })
  }
  logout() {
    localStorage.removeItem('_user');
    this.cService.setIsLogin(false);
    this.router.navigate(['/']);
  }
}
